// extracted by mini-css-extract-plugin
export default {"container":"PleaseSupportUs_container__rpCVE"};